import { Button, Grid, ScrollArea } from "@mantine/core";
import { observer } from "mobx-react";
import t from "../../stores/language";
import InputSelector from "./input-selector";
import ResultView from "./result-view";
import { useStyles } from "./configure-input";
import { useParams } from "react-router-dom";
import { useStore } from "../../stores/store";
import theme from "../../stores/theme";
import { FormulaResult } from "../../models/models";

export const ValidateFormula = observer(function ValidateFormula() {
  const { classes } = useStyles();
  const { store } = useStore();
  const { id } = useParams();

  const refresh = async () => {
    if (store.validateInputs(store.selectedInputs ?? {})) {
      await store.EvaluateFormulas(store.selectedInputs ?? {}, id ?? "0").then((data: FormulaResult | null) => {
        if (data == null) return;
        store.SetResults(data?.result ?? []);
        store.SetErrors(data?.errors ?? []);
      });
    }
  };

  return (
    <Grid gutter={10} className={classes.container}>
      <Grid.Col className={classes.parts} span={6}>
        <Grid.Col className={classes.partHeader} span={12}>
          {t("Configured Inputs")}
        </Grid.Col>
        <ScrollArea style={{ height: theme.other?.table.height }} offsetScrollbars>
          <InputSelector span={6} />
        </ScrollArea>
      </Grid.Col>
      <Grid.Col className={classes.parts} span={6}>
        <Grid.Col style={{ justifyContent: "space-between" }} className={classes.partHeader} span={12}>
          {
            <>
              <span>{t("Calculation Results")}</span>
              <Button onClick={refresh} size="xs">
                {t("Recalculate")}
              </Button>
            </>
          }
        </Grid.Col>
        <ResultView />
      </Grid.Col>
    </Grid>
  );
});
